import { CloudUploadOutlined } from "@ant-design/icons";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { App, Button, Space, Typography } from "antd";
import { useErrorText } from "@/api/errors";
import { useI18n } from "@/i18n";
import { requestVideoUpload } from "./agent";

/**
 * A packing video kept on the packing laptop (recorder agent): played there,
 * or asked to come up to Zerpid for a complaint.
 */
export function VideoOnDevice({ orderId, requested }: { orderId: string; requested: boolean }) {
  const { t } = useI18n();
  const { message } = App.useApp();
  const errorText = useErrorText();
  const queryClient = useQueryClient();
  const ask = useMutation({
    mutationFn: () => requestVideoUpload(orderId),
    onSuccess: () => {
      void message.success(t("wms.agent.requested"));
      void queryClient.invalidateQueries({ queryKey: ["packing", "order", orderId] });
    },
    onError: (err) => void message.error(errorText(err)),
  });
  return (
    <Space orientation="vertical" size={4}>
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        {t("wms.agent.onLaptop")}
      </Typography.Text>
      {requested ? (
        <Typography.Text type="warning" style={{ fontSize: 12 }}>
          {t("wms.agent.waitingUpload")}
        </Typography.Text>
      ) : (
        <Button size="small" icon={<CloudUploadOutlined />} loading={ask.isPending} onClick={() => ask.mutate()}>
          {t("wms.agent.requestUpload")}
        </Button>
      )}
    </Space>
  );
}
